
  <syslink-tag
    [color]="color"
    [value]="value | translate"
    [fill]="true"
  ></syslink-tag>

